//  @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Page,
  Row,
  Col,
  Button,
  Notification,
  DatePicker,
} from "components/Atoms";

import * as ActionTypes   from 'constants/ActionTypes';
import * as Actions       from "actions/seller/seller.subscription";


import AvailablePlan      from "components/elements/seller/AvailablePlan";

import "./styles.scss";
import {useEffect, useState} from "react";
// Component Imports


const SubscriptionStore = (props) => {

  const [state, setState] = useState({ itemsInCart: false });

  const {
    serviceError, reqStatus, isLoading,
    getAllSubscriptions, addSubscriptionToCart, removeSubscriptionFromCart,
    availablePlans, checkoutSubscriptionPlan,
    history
  } = props;

  const itemsInCart = availablePlans.filter((plan) => plan.addedToCart)
      .length;
  const checkOutReady = itemsInCart > 0;

  useEffect(() => {
    getAllSubscriptions();
  }, []);


  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      case ActionTypes.CHECKOUT_SUBSCRIPTION_SUCCESS:
        history.push(`/subscription/checkout`);
        break;
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const addToCart = (plan) => () => {
    addSubscriptionToCart(plan);
  };

  const removeFromCart = (plan) => () => {
    removeSubscriptionFromCart(plan);
  };

  const checkoutSubscriptionPlanCall = () => {
    const plansToCheckOut = availablePlans.filter((plan) => plan.addedToCart);
    checkoutSubscriptionPlan(plansToCheckOut);
  };


    return (
      <Page
        className="subscriptions-home"
      >
        <h4 className="page-title">Available Subscriptions</h4>
        <Row gutter={[24, 24]}>
          {availablePlans.map((availablePlan, index) => {
            return (
              <Col xs={24} md={12} lg={8} key={index}>
                <AvailablePlan
                  data={availablePlan}
                  addToCart={addToCart(availablePlan)}
                  removeFromCart={removeFromCart(availablePlan)}
                />
              </Col>
            );
          })}
        </Row>
        {checkOutReady && (
          <Button
            type="primary"
            size="large"
            className="m-fit"
            onClick={checkoutSubscriptionPlanCall}
          >
            {`Checkout ${itemsInCart} Plan(s)`}
          </Button>
        )}
      </Page>
    );
}
// Mapping Props and State.
const _SubscriptionStore = connect(
  ({ subscriptions, appBase }) => ({
    appBase: appBase,
    reqStatus: subscriptions.reqStatus,
    isLoading: subscriptions.isLoading,
    serviceError: subscriptions.serviceError,
    availablePlans: subscriptions.availablePlans,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch)
)(SubscriptionStore);

export { _SubscriptionStore as default };
